export default "__VITE_ASSET__CexiFEHG__"